import { render, staticRenderFns } from "./AssignOfficer.vue?vue&type=template&id=635dd10a&scoped=true&"
import script from "./AssignOfficer.vue?vue&type=script&lang=js&"
export * from "./AssignOfficer.vue?vue&type=script&lang=js&"
import style0 from "./AssignOfficer.vue?vue&type=style&index=0&id=635dd10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635dd10a",
  null
  
)

export default component.exports